<template>
  <BaseNode v-bind="props">
    <template #body>
      <BaseHtmlContent class="node__message" :html="processText(node.message, decisionTree.context)" />
    </template>
  </BaseNode>
</template>

<script setup>
import { useSnippetProcessor } from "#/decision_tree_viewer/composables/useSnippetProcessor";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const { processText } = useSnippetProcessor();
</script>
